import { FiAlertTriangle, FiInbox } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

export const LoadingSkeleton = ({ rows = 4 }) => {
  const { t } = useTranslation();
  return <div className='space-y-3' aria-label={t('Loading')}>
    {Array.from({ length: rows }).map((_, index) => (
      <div
        key={index}
        className='h-12 animate-pulse rounded-[var(--radius-md)] bg-slate-200/80 dark:bg-slate-700/70'
      />
    ))}
  </div>;
};

export const EmptyState = ({ title, description }) => (
  <div className='flex min-h-48 flex-col items-center justify-center rounded-[var(--radius-md)] border border-dashed border-[var(--border-strong)] bg-[var(--surface-panel-muted)] p-8 text-center'>
    <FiInbox className='mb-3 text-3xl text-[var(--text-muted)]' aria-hidden='true' />
    <h3 className='text-base font-semibold text-[var(--text-primary)]'>{title}</h3>
    {description && <p className='mt-2 text-sm text-[var(--text-secondary)]'>{description}</p>}
  </div>
);

export const ErrorState = ({ title, description, actionLabel, onAction }) => (
  <div className='rounded-[var(--radius-md)] border border-red-200 bg-red-50 p-4 text-red-900 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-100'>
    <div className='flex gap-3'>
      <FiAlertTriangle className='mt-0.5 shrink-0' aria-hidden='true' />
      <div>
        <h3 className='font-semibold'>{title}</h3>
        {description && <p className='mt-1 text-sm opacity-90'>{description}</p>}
        {onAction && (
          <button
            type='button'
            onClick={onAction}
            className='mt-3 rounded-[var(--radius-md)] border border-current px-3 py-1.5 text-sm font-semibold hover:bg-red-100 dark:hover:bg-red-900/30'
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  </div>
);
